import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {ArticleType} from "./article-type.model";
import {environment} from "../../../environments/environment";

@Injectable({providedIn: 'root'})
export class ArticleTypeService {

  constructor(private http: HttpClient) {
  }

  getAllArticleTypes(clientId: number): Observable<ArticleType[]> {
    return this.http.get<ArticleType[]>(`${environment.rootUrl}/article-type/get-all-by-client/${clientId}`);
  }

  getCurrentArticleTypes(articleId: string | undefined): Observable<ArticleType[]> {
    if (!articleId) return of([])
    return this.http.get<ArticleType[]>(`${environment.rootUrl}/article-type/get-order-by-article/${articleId}`);
  }
}
